module.exports = __webpack_public_path__ + "static/paris-022.thumb-a760e2724c57124d74996296c4a763ae.jpg";